(function () {
  function fixInitialVariantMedia() {
    if (!window.jQuery) return;
    var $ = window.jQuery;
    var params = new URLSearchParams(window.location.search);
    var variantId = params.get('variant');
    if (!variantId) return;

    $('[data-section-type="product-template"]').each(function () {
      var container = this;
      var sectionId = container.getAttribute('data-section-id');
      var productJsonEl = document.getElementById('ProductJson-' + sectionId);
      if (!productJsonEl) return;

      var product;
      try {
        product = JSON.parse(productJsonEl.textContent);
      } catch (e) {
        return;
      }

      var variant = (product.variants || []).filter(function (v) {
        return String(v.id) === String(variantId);
      })[0];
      if (!variant || !variant.featured_media) return;

      var mediaId = sectionId + '-' + variant.featured_media.id;
      var $newMedia = $(
        '[data-product-single-media-wrapper][data-media-id="' + mediaId + '"]'
      );
      if (!$newMedia.length) return;

      var $group = $('[data-product-single-media-group]', container);
      var $flexWrapper = $newMedia.closest(
        '[data-product-single-media-flex-wrapper]'
      );
      if (!$flexWrapper.length || !$group.length) return;

      if ($group.hasClass('slick-initialized')) {
        // Mobile: a carousel is already managing these slides. Use its own
        // navigation API instead of moving DOM nodes, which would desync
        // Slick's internal slide index from the actual markup.
        var slideIndex = $flexWrapper.data('slick-index');
        if (slideIndex !== undefined) {
          $group.slick('slickGoTo', slideIndex, true);
        }
      } else {
        // Desktop: stacked layout, no carousel. Move the correct photo to
        // the top, same as the theme's own variant-change behaviour.
        var currentScroll = $(document).scrollTop();
        $flexWrapper.prependTo($group);
        $(document).scrollTop(currentScroll);
      }

      $('[data-product-thumbnail]').removeClass('active-thumb');
      $('[data-product-thumbnail][data-media-id="' + mediaId + '"]').addClass(
        'active-thumb'
      );
    });
  }

  window.addEventListener('load', fixInitialVariantMedia);
})();
